import React from "react";
import todo from "../assets/index.png";
import cf from "../assets/cf.png";
import { FiExternalLink } from "react-icons/fi";

function Work() {
  return (
    <div name="work" className="w-full md:h-screen bg-[#F3DFBF]">
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div className="pb-1">
          <p className="text-4xl mt-64 font-bold inline-block border-b-4 border-[#008148] text-[#008148]">
            Work
          </p>
          <p className="py-4 text-xl">Progetti personali</p>
        </div>

        {/*Container */}
        <div className="flex flex-col gap-8">
          {/*Grid Item */}
          <div className="grid grid-cols-2 gap-4 items-center">
            <div className="shadow-lg shadow-[#dbcdb8] container rounded-md overflow-hidden">
              <img
                src={cf}
                alt="Calcolo del codice fiscale"
                className="w-full h-full object-contain"
              />
            </div>
            {/* Hover Effects */}
            <div className="text-black tracking-wider flex flex-col justify-center items-center">
              <h2 className="text-center text-3xl font-bold">
                Calcolo del codice fiscale
              </h2>
              <h3 className="text-xl font-bold">Tecnologie:</h3>
              <p className="text-lg">C#, Windows form</p>
              <a
                href="https://github.com/nicola-saladino/Calcolo-Codice-Fiscale"
                target="_blank"
                rel="noopener noreferrer"
                className="text-center text-black group border-2 border-[#008148] px-8 py-1 my-1 hover:bg-[#008148] hover:text-[#fff] rounded-md"
              >
                Code{" "}
                <FiExternalLink className="ml-3 group-hover:rotate-45 duration-300" />
              </a>
            </div>
          </div>

          {/*Grid Item */}
          <div className="grid grid-cols-2 gap-4 items-center">
            <div className="shadow-lg shadow-[#dbcdb8] container rounded-md overflow-hidden">
              <img
                src={todo}
                alt="Todo-List"
                className="w-full h-full object-contain"
              />
            </div>
            {/* Hover Effects */}
            <div className=" text-black tracking-wider flex flex-col justify-center items-center">
              <h2 className="text-center text-3xl font-bold">Todo-List</h2>
              <h3 className="text-xl font-bold">Tecnologie:</h3>
              <p className="text-lg">JSP, JavaEE</p>
              <a
                href="https://github.com/nicola-saladino/TodoList-JSP"
                target="_blank"
                rel="noopener noreferrer"
                className="text-center text-black group border-2 border-[#008148] px-8 py-1 my-1 hover:bg-[#008148] hover:text-[#fff] rounded-md"
              >
                Code{" "}
                <FiExternalLink className="ml-3 group-hover:rotate-45 duration-300" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Work;
